var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93.542,
    height: 74.558,
    viewBox: "0 0 93.542 74.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2099",
    "data-name": "Rectangle 2099",
    width: 93.542,
    height: 74.558,
    transform: "translate(1654.968 408.729)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(-1654.968 -408.729)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4194",
    "data-name": "Group 4194",
    transform: "translate(1672.76 417.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14244",
    "data-name": "Path 14244",
    d: "M18.075,30.149A12.075,12.075,0,1,1,30.149,18.075,12.075,12.075,0,0,1,18.075,30.149Z",
    transform: "translate(-6 -6)",
    fill: "#03a998"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14245",
    "data-name": "Path 14245",
    d: "M6,60.543,60.541,6l3.417,3.417L9.415,63.958Z",
    transform: "translate(-6 -6)",
    fill: "#03a998"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14246",
    "data-name": "Path 14246",
    d: "M39.075,51.149A12.075,12.075,0,1,1,51.149,39.075,12.075,12.075,0,0,1,39.075,51.149Z",
    transform: "translate(6.808 6.809)",
    fill: "#03a998"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/Percent.cb8071fd5cc7366e7b19c8e63c4b2169.svg";
export { ForwardRef as ReactComponent };